<!--Navigation Bar-->
<app-navbar>
    <h2>Articol</h2>
</app-navbar>

<div class="blog-details-area ptb-100" *ngIf="isLoaded">
    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="blog-details-item">
                    <div class="blog-details-img">
                        <img src="{{blogDetails.photoPath}}" alt="Blog Details">
                        <h3>{{blogDetails.title}}</h3>
                        <ul>
                            <li><i class="icofont-calendar"></i>{{blogDetails.postingDate | date:'dd-MM-yyyy HH:mm'}}
                            </li>
                            <li><i class="icofont-user-alt-7"></i>{{blogDetails.userName}}</li>
                        </ul>

                        <div [innerHtml]=blogDetails.content></div>
                    </div>

                    <div class="blog-details-social">
                        <span>Distribuie:</span>

                        <share-buttons [theme]="'default'"
                                       [include]="['facebook','linkedin']"
                                       [show]="2"
                                       [url]=currentUrl
                        ></share-buttons>
                    </div>
                </div>
            </div>

<!--            <div class="col-lg-4 col-12">-->
<!--                <div class="blog-details-item">-->
<!--                    <div class="single-resume-category">-->
<!--                        <h3>Categorii</h3>-->

<!--                        <ul>-->
<!--                            <li><a routerLink="/blog">Marketing</a><span>({{marketingElem}})</span></li>-->
<!--                            <li><a routerLink="/blog">Management</a><span>({{managementElem}})</span></li>-->
<!--                            <li><a routerLink="/blog">Vanzari</a><span>({{salesElem}})</span></li>-->
<!--                            <li><a routerLink="/blog">Recrutare</a><span>({{recrutElem}})</span></li>-->
<!--                        </ul>-->
<!--                    </div>-->

<!--                </div>-->
<!--            </div>-->
        </div>
    </div>
</div>


<!--Footer-->
<app-footer></app-footer>
